export const MAIN_TAB_INDEX = 0;
export const CATEGORIES_TAB_INDEX = 1;
export const SETTINGS_TAB_INDEX = 2;
export const LAYOUT_TAB_INDEX = 3;
export const DISPLAY_TAB_INDEX = 4;
export const DESIGN_TAB_INDEX = 5;
export const SUPPORT_TAB_INDEX = 6;
export const ADDONS_TAB_INDEX = 7;

export const biTabNames = {
  [MAIN_TAB_INDEX]: 'Main',
  [CATEGORIES_TAB_INDEX]: 'Categories',
  [SETTINGS_TAB_INDEX]: 'Settings',
  [LAYOUT_TAB_INDEX]: 'Layout',
  [DISPLAY_TAB_INDEX]: 'Display',
  [DESIGN_TAB_INDEX]: 'Design',
  [SUPPORT_TAB_INDEX]: 'Support',
  [ADDONS_TAB_INDEX]: 'Add-Ons',
};

export const DESIGN_TAB_HEADER = 'design-tab.header';
export const DESIGN_TAB_POSTS = 'design-tab.posts';
export const DESIGN_TAB_ICONS_BUTTONS = 'design-tab.icons-buttons';

export const designTabNames = {
  0: DESIGN_TAB_HEADER,
  1: DESIGN_TAB_POSTS,
  2: DESIGN_TAB_ICONS_BUTTONS,
};

export const MODAL_SIZES = {
  addOn: numOfAddOns => ({
    width: 834,
    height: 22 + 205 * numOfAddOns, // 22 + (205 * 2) <- top-bottom-margins + 205 * number-of-add-ons
  }),
};
